const KpiCard = ({ title, children, className = "" }) => {
  return (
    <div className={`bg-white rounded-lg p-5 shadow-sm border border-gray-100 ${className}`}>
      <h3 className="text-base font-semibold text-black text-center mb-4">{title}</h3>
      {children}
    </div>
  );
};

export default KpiCard;
